<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / Cadastro/Equipamento/Acessórios </label>
      <router-link to="/acessorio"></router-link>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="acessorios.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="6" sm="6">
            <v-text-field
              label="Acessório *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Acessório é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              label="Observação"
              v-model="observacao"
              v-uppercase
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addAcessorio()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-card>
        <v-data-table
          :headers="headers"
          hide-default-footer
          disable-pagination
          :items="acessoriosLocal"
          :loading="loading"
          loading-text="Buscando dados..."
        >
          <template v-slot:item.ativo="{ item }">
            <v-checkbox
              v-model="item.ativo"
              :label="item.ativo === true ? 'Ativo' : 'Inativo'"
            ></v-checkbox>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="error"
                  @click="removeAcessorio(item.index)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-close-thick
                </v-icon>
              </template>
              <span>Remover</span> </v-tooltip
            ><v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="info"
                  @click="editaAcessorio(item.index)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-row align="center">
        
        <v-col>
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn @click="enviar" color="success" class="mr-4">Salvar</v-btn>
            </template>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>

    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="750px"
      title="Editar"
      ><v-card>
        <v-card-title>
          <span class="headline">{{ this.labelModal }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formEdit" v-model="validFrm2" lazy-validation>
              <v-row align="center">
          <v-col cols="6" sm="6">
            <v-text-field
              label="Acessório *"
              v-model="descricaoEdit"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Acessório é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              label="Observação"
              v-model="observacaoEdit"
              v-uppercase
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn @click="showModal = false" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="atualizar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--<Modal v-model="showModal" modalStyle="max-width: 750px" title="Editar">
      <v-form ref="formEdit" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="6" sm="6">
            <v-text-field
              label="Acessório"
              v-model="descricaoEdit"
              :counter="200"
              :rules="[(v) => !!v || 'O Acessório é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="6">
            <v-text-field
              label="Observação"
              v-model="observacaoEdit"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn @click="showModal = false" color="error" class="mr-4" text> Cancelar </v-btn>
          <v-btn @click="atualizar" color="success" class="mr-4" text> Salvar </v-btn>
        </v-col>
      </v-row>
    </Modal>-->

  </div>
</template>

<script>
import { enviarAcessoriosAsync } from "@/services/acessorioService";
import { downloadLista } from "@/services/acessorioService";
import { getUserRoles } from "@/services/loginService";
import { mapState, mapActions } from "vuex";

export default {
  name: "criarAcesorio",
  data: () => ({
    valid: true,
    overlay: false,
    showModal: false,
    descricao: null,
    observacao: null,
    descricaoEdit: null,
    observacaoEdit: null,
    indexEdit: null,
    acessoriosLocal: [],
    headers: [
      { text: "Id", value: "id", sortable: false },
      { text: "Acessório", value: "descricao", sortable: false },
      { text: "Observação", value: "observacao", sortable: false },
      { text: "Status", value: "ativo", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("equipamento", ["acessorios"]),
  },
  methods: {
    ...mapActions("equipamento", ["atualizarAcessorios"]),
    async enviar() {
      this.overlay = true;
        const resposta = await enviarAcessoriosAsync(this.acessoriosLocal);
        if (resposta) {
          this.obterLista() 
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.obterLista() 
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.overlay = false;
          //this.$router.push("/acessorio");
        }
    },
    baixarlista() {
      downloadLista();
    },
    addAcessorio: function (e) {
      if (!this.$refs.form.validate()) {
        e.preventDefault();
      }
      var acessorio = new Object();

      acessorio.id = null;
      acessorio.descricao = this.descricao;
      acessorio.observacao = this.observacao;
      acessorio.ativo = true;

      acessorio.index =
        this.acessoriosLocal.length === 0
          ? 0
          : this.acessoriosLocal[this.acessoriosLocal.length - 1].index + 1;

      this.acessoriosLocal.push(JSON.parse(JSON.stringify(acessorio)));
      this.descricao = null;
      this.observacao = null;
      this.$refs.form.resetValidation();
    },

    editaAcessorio(index) {
      this.indexEdit = index;
      var acessorio = this.acessoriosLocal.filter((e) => e.index === this.indexEdit);
      this.descricaoEdit = acessorio[0].descricao;
      this.observacaoEdit = acessorio[0].observacao;
      this.showModal = true;
    },
    removeAcessorio(index) {
      this.acessoriosLocal = this.acessoriosLocal.filter((e) => e.index != index);
    },
    atualizar: function (e) {
      if (!this.$refs.formEdit.validate()) {
        e.preventDefault();
      }
      this.acessoriosLocal[this.indexEdit].descricao = this.descricaoEdit;
      this.acessoriosLocal[this.indexEdit].observacao = this.observacaoEdit;
      this.showModal = false;
      this.descricaoEdit = null;
      this.observacaoEdit = null;
      this.indexEdit = null;
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarAcessorios();
      this.acessoriosLocal = this.acessorios.slice(0);
      for (var i = 0; i < this.acessoriosLocal.length; i++) {
        this.acessoriosLocal[i].index = i;
      }
      this.loading = false;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoEquipamento: () =>
      import("@/components/Tabs/TabCadastroEquipamento"),
  },
};
</script>